// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.paliwallet",
    name: "Pali Wallet",
    homepage: "https://paliwallet.com",
    image_id: "4672cbde-0f96-42f3-84a0-524e9ad70a00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/pali-wallet-dex-nft-defi/id6447639615",
        android: "https://play.google.com/store/apps/details?id=io.paliwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://play.google.com/store/apps/details?id=io.paliwallet",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "paliwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map